<template>
  <div class="card">
    <div class="github-card" v-if="!isLoading">
      <GitHubCard
        :class="`svg ${isLabFinished ? 'green' : ''}`"
        v-if="labType === 'github'"
      />
      <AzureCard
        :class="`svg ${isLabFinished ? 'green' : ''}`"
        v-if="labType === 'azure'"
      />
      <div class="card-text">
        <h2>{{ cardTitle }}</h2>
        <p>This link will launch another browser tab.</p>
        <a
          class="button transparent"
          @click="setLabStatus('started')"
          :href="lab.external_url"
          target="_blank"
        >
          {{ buttonText }}
        </a>
        <div class="finish-data">
          <CheckIcon :fill="isLabFinished ? '#00DEA0' : '#727276'" />
          <button
            class="mark-as-finish-btn"
            @click="toggleLabStatus()"
            :disabled="isLoadingLab"
          >
            <span v-if="!isLabFinished">Mark as finished</span>
            <span v-else>Mark as unfinished</span>
          </button>
          <i
            v-if="isLabFinished"
            class="material-icons info-icon"
            role="presentation"
            v-tooltip="{
              content: `Finished on ${labFinishedTime}`,
              placement: 'top-center',
            }"
          >
            info_outline
          </i>
          <ActionLoader v-if="isLoadingLab" name="ball-clip-rotate" />
        </div>
      </div>
    </div>
    <div v-else class="github-card">
      <ActionLoader
        name="ball-clip-rotate"
        loaderClass="card__loading-spinner"
      />
    </div>
  </div>
</template>
<script>
import { format } from 'date-fns'
import GitHubCard from '@/assets/icons/course/lab/github-card.svg'
import AzureCard from '@/assets/icons/course/lab/azure-card.svg'
import CheckIcon from '@/assets/icons/course/exercise/check-circle.svg'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import CONSTANTS from '@/constants'

export default {
  components: {
    GitHubCard: { ...GitHubCard, name: 'GitHubCard' },
    AzureCard: { ...AzureCard, name: 'AzureCard' },
    CheckIcon: { ...CheckIcon, name: 'CheckIcon' },
    ActionLoader,
  },
  props: {
    lab: Object,
    setLabStatus: Function,
    isLoading: Boolean,
  },
  data: () => {
    return {
      isLoadingLab: false,
    }
  },
  computed: {
    isLabFinished() {
      return this.lab.user_status === CONSTANTS.CONTENT_USER_STATUS.FINISHED
    },
    labFinishedTime() {
      // November 17, 2020 8:47 PM
      return format(
        new Date(this.lab.user_status_modified),
        'LLLL d, yyyy hh:mm a'
      )
    },
    labType() {
      return this.lab.lab_type || ''
    },
    cardTitle() {
      let title = ''
      switch (this.labType) {
        case 'github':
          title = 'Open Project'
          break
        case 'azure':
          if (this.isLabFinished) {
            title = 'Open Task'
          } else {
            title = 'Start Task'
          }
          break
        default:
          break
      }
      return title
    },
    buttonText() {
      let text = ''
      switch (this.labType) {
        case 'github':
          text = 'GET STARTED'
          break
        case 'azure':
          text = 'OPEN AZURE PORTAL'
          break
        default:
          break
      }
      return text
    },
  },
  methods: {
    async toggleLabStatus() {
      this.isLoadingLab = true
      await this.setLabStatus(
        this.isLabFinished
          ? CONSTANTS.CONTENT_USER_STATUS.UNSTARTED
          : CONSTANTS.CONTENT_USER_STATUS.FINISHED
      )
      this.isLoadingLab = false
    },
  },
}
</script>
<style lang="scss" scoped>
.card {
  .github-card {
    color: white;
    max-height: 243px;
    max-width: 530px;
    display: flex;
    background: black;
    border-radius: 10px;
    h2 {
      margin-bottom: 5px;
    }
    p {
      margin-bottom: 15px;
    }
    .svg {
      width: 390px;
      fill: #ef6e22;
      &.green {
        fill: #08b16a;
      }
    }
  }
  .button {
    border-radius: 15px;
    padding: 5px 10px;
    font-size: 11px;
    color: white;
    border: 1px solid var(--orange);
    margin-top: 10px;
  }
  .card-text {
    text-align: left;
    padding: 30px 20px 15px;
  }

  .finish-data {
    display: flex;
    font-size: 0.85em;
    margin-top: 38px;
    align-items: center;

    .mark-as-finish-btn {
      background: transparent;
      color: var(--white);
      font-weight: 700;
      border: none;
      border-bottom: 1px solid var(--white);
      display: flex;
      align-items: center;
      padding: 0px;
      margin: 0px 5px 0 10px;
      cursor: pointer;
    }

    .info-icon {
      color: var(--lighter-gray);
      font-size: 16px;
      margin-right: 5px;
    }
  }
}
</style>
